import { useContext, useState, useRef, useEffect } from 'react';
import { MyContext } from '../../Context/MyProvider';
import LocationInput from '../Model/LocationInput';
import { AnimatePresence, motion } from 'framer-motion';
import BtnLoader from '../BtnLoader';
import Map from '../Map';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PageLoader from '../PageLoader';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import ImageLoad from '../ImageLoad';
import DatePicker from './DatePicker';
import TimePicker from './TimePicker';
import PriceModel from '../Model/PriceModel';
import Payment from '../Payment/Payment';
import { useTranslation } from 'react-i18next';
import { socket } from '../../socket';

const Category = () => {
    const { t } = useTranslation();
    const { BaseUrl, handleCallApi, setShowToast, setToastMsg, ranningData } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [step, setStep] = useState(1);
    const [pickupLocation, setPickupLocation] = useState(null);
    const [dropLocation, setDropLocation] = useState(null);
    const [stopList, setStopList] = useState([]);
    const [showModel, setShowModel] = useState("");
    const [selectedStopIndex, setSelectedStopIndex] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [searchData, setSearchData] = useState([]);
    const [apiLoading, setApiLoading] = useState("");
    const [modelType, setModelType] = useState("");
    const [currentads, setCurrentAds] = useState("");
    const [modelData, setModelData] = useState("");
    const [selectDate, setSelectDate] = useState("");
    const [selectTime, setSelectTime] = useState("");
    const [fareCalculate, setFareCalculate] = useState(null);
    const [paymentList, setPaymentList] = useState([]);
    const [selectPayment, setSelectPayment] = useState("");
    const [couponList, setCouponList] = useState([]);
    const [selectCoupon, setSelectCoupon] = useState(null);
    const [isModel, setIsModel] = useState("");
    const [packageData, setPackageData] = useState({ kg: "", length: "", weight: "", height: "", desc: "" });
    // eslint-disable-next-line no-unused-vars
    const [recentUpdateTrigger, setRecentUpdateTrigger] = useState(0);

    const searchRef = useRef(null);
    const FetchRef = useRef(false);
    const params = useParams();
    const navigate = useNavigate();

    const currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        handleGetPaymentList();
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        handleRideRaning(ranningData);
    }, [ranningData]);

    const handleRideRaning = (data) => {
        if (!data) {
            if (showModel === "Price") {
                setShowModel("");
                setFareCalculate(null);
            }
            return;
        }

        const role = data.m_role;
        const currentCategory = params.title;
        const expectedRole = currentCategory === "outstation" ? "2" : currentCategory === "hourly-rental" ? "3" : currentCategory === "package" ? "4" : "1";

        if (role !== expectedRole) return;

        const { pick_add, pick_latlon, drop_add, drop_latlon, drop_add_list, drop_latlon_list, increased_time, bidding_status, price } = data;

        if ((price && bidding_status) || data.status == '0') {
            const ModelData = {
                ...data,
                tot_price: price || data.tot_price,
                bid_addjust_amount: price || data.tot_price,
                bidding: bidding_status || data.bidding,
            }
            setFareCalculate(ModelData);
        }

        if (pick_add || pick_latlon) {
            setPickupLocation({
                title: pick_add?.title,
                subt: pick_add?.subtitle || pick_add?.subt || "",
                lat: Number(pick_latlon?.latitude),
                lng: Number(pick_latlon?.longitude),
            });
        }

        if (drop_add || drop_latlon) {
            setDropLocation({
                title: drop_add?.title,
                subt: drop_add?.subtitle || drop_add?.subt || "",
                lat: Number(drop_latlon?.latitude),
                lng: Number(drop_latlon?.longitude),
            });
        }

        if (drop_add_list || drop_latlon_list) {
            const list = drop_add_list.map((item, index) => ({
                title: item?.title,
                subt: item?.subtitle || item?.subt || "",
                lat: Number(drop_latlon_list[index]?.latitude),
                lng: Number(drop_latlon_list[index]?.longitude),
            }));
            setStopList(list);
        }

        if (increased_time || data.status == '0') {
            setShowModel("Price");
        }
    };

    useEffect(() => {
        if (!searchText || searchText.trim().length < 3) {
            setSearchData([]);
            return;
        }

        const debounce = setTimeout(async () => {
            try {
                setApiLoading("Location");

                const res = await handleCallApi(
                    "Get",
                    `customer/web_map_data?text=${searchText}`
                );

                const results = res?.data?.results || [];

                if (!results.length) {
                    setShowToast(true);
                    setToastMsg(`Location "${searchText}" not found !!`);
                }

                setSearchData(results);
            } catch (err) {
                console.error(err);
            } finally {
                setApiLoading("");
            }
        }, 300);

        return () => clearTimeout(debounce);
    }, [searchText]);

    useEffect(() => {
        if (showModel && searchRef.current) {
            searchRef.current.focus();
        }

        if (showModel) {
            setModelType(showModel);
        }

        document.body.style.overflow = showModel ? "hidden" : "auto";
    }, [showModel]);

    const handleGetPaymentList = async () => {
        if (FetchRef.current) return;
        FetchRef.current = true;
        let serviceType = "";
        if (params.title === "outstation") serviceType = "outstation";
        else if (params.title === "hourly-rental") serviceType = "rental";
        else if (params.title === "package") serviceType = "package";

        const Response = await handleCallApi("Get", `customer/coupon_payment?service=${serviceType}`);
        const PaymentList = Response.data.payment_list;
        setPaymentList(PaymentList);
        setCouponList(Response.data.coupon_list);
        const GetCashData = PaymentList.find((item) => item.name === "Cash");
        setSelectPayment(GetCashData);
        setLoading(false);
    }

    const saveRecentSearch = (location) => {
        try {
            const rawRecents = localStorage.getItem("recent_searches");
            let recents = rawRecents ? JSON.parse(rawRecents) : [];
            recents = recents.filter(item => item.title !== location.title);
            recents.unshift(location);
            recents = recents.slice(0, 5);
            localStorage.setItem("recent_searches", JSON.stringify(recents));
        } catch (e) {
            console.error("Failed to save recent search", e);
        }
    };

    const handleGetCurrentLocation = () => {
        if (!navigator.geolocation) {
            setShowToast(true);
            setToastMsg(t("Geolocation is not supported by your browser"));
            return;
        }

        setApiLoading("Location");
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                try {
                    const response = await handleCallApi(
                        "Get",
                        `customer/reverse_geocode?lat=${lat}&lng=${lng}`
                    );

                    if (response.data && response.data.results && response.data.results.length > 0) {
                        const result = response.data.results[0];
                        const placeData = {
                            name: result.formatted_address.split(",")[0] || "Current Location",
                            formatted_address: result.formatted_address,
                            geometry: {
                                location: {
                                    lat: lat,
                                    lng: lng
                                }
                            }
                        };
                        handleSelectLocation(placeData);
                    } else {
                        setShowToast(true);
                        setToastMsg(t("Could not fetch address for your location."));
                    }
                } catch (err) {
                    console.error("Error geocoding location:", err);
                    setShowToast(true);
                    setToastMsg(t("Error getting location address."));
                } finally {
                    setApiLoading("");
                }
            },
            (error) => {
                console.error("Geolocation error:", error);
                setShowToast(true);
                setToastMsg(t("Location permission denied or unavailable."));
                setApiLoading("");
            }
        );
    };

    const handleSelectLocation = (data) => {
        const LocationData = {
            title: data.name,
            subt: data?.formatted_address || "",
            lat: data.geometry.location.lat,
            lng: data.geometry.location.lng,
        }

        saveRecentSearch(LocationData);

        if (modelType === "Pickup") {
            setPickupLocation(LocationData);

        } else if (modelType === "Drop") {
            setDropLocation(LocationData);

        } else if (modelType === "Stop") {
            const updatedStops = [...stopList];
            updatedStops[selectedStopIndex] = LocationData;
            setStopList(updatedStops);
        }

        closeModal();
    }

    const addStop = () => {
        if (stopList.length >= 1 && !stopList[stopList.length - 1]) {
            setShowToast(true);
            setToastMsg("Please enter data in the previous field first !!");
            return;
        }
        setStopList((prev) => [...prev, null]);
    };

    const removeStop = (index) => {
        setStopList((prev) => prev.filter((_, i) => i !== index));
    };

    const moveStopUp = (index) => {
        if (index === 0) return;
        const newList = [...stopList];
        const temp = newList[index];
        newList[index] = newList[index - 1];
        newList[index - 1] = temp;
        setStopList(newList);
    };

    const moveStopDown = (index) => {
        if (index === stopList.length - 1) return;
        const newList = [...stopList];
        const temp = newList[index];
        newList[index] = newList[index + 1];
        newList[index + 1] = temp;
        setStopList(newList);
    };

    const closeModal = () => {
        setSearchText("");
        setSearchData([]);
        setShowModel("");
    };

    const HandleGetGoogleAddress = async (lat, lng) => {
        try {
            const response = await handleCallApi(
                "Get",
                `customer/reverse_geocode?lat=${lat}&lng=${lng}`
            );
            if (response.data && response.data.results && response.data.results.length > 0) {
                const fulladdress = {
                    name: response.data.results[0]?.formatted_address,
                    formatted_address: "",
                    ...response.data.results[0]
                };
                setCurrentAds(fulladdress);
            } else {
                setShowToast(true);
                setToastMsg(t("Could not fetch address for your location."));
            }
        } catch (error) {
            console.error("Error fetching address:", error);
            setShowToast(true);
            setToastMsg(t("Error getting location address."));
            return "";
        }
    };

    const handleDateChange = (newDate) => {
        setSelectDate(newDate);
        setShowModel("");
    };

    const handleTimeSelect = (newTime) => {
        setSelectTime(newTime);
    }

    const handleCancelRequest = async () => {
        const uid = secureLocalStorage.getItem("Userid");
        const Response = await handleCallApi("Post", "customer/remove_vehicle_request", { uid });
        setShowToast(true);
        setToastMsg(Response?.data?.message);
        if (Response.data.ResponseCode) {
            setShowModel("");
        }
    }

    const handleRequestTimeOut = async (requestId) => {
        const uid = secureLocalStorage.getItem("Userid");
        const Response = await handleCallApi("Post", "customer/timeout_vehicle_request", { request_id: requestId, uid });
        if (Response?.data?.Result) {
            socket.emit("RequestTimeOut", {
                requestid: Response.data?.id,
                driverid: Response.data?.driverid
            });
        }
    }

    const handleChange = (e) => {
        const value = Number(e.target.value);

        if (value > modelData?.num_of_kg) {
            setShowToast(true);
            setToastMsg(t("max_weight", { kg: modelData?.num_of_kg }));
            return;
        }

        setPackageData({ ...packageData, kg: value });

    };

    return (
        <div className="find-ride-page">

            <div className="find-container px-3">
                <div className="h-full lg:h-[calc(100vh-100px)] flex flex-col-reverse lg:flex-row items-start gap-6">

                    <div className="w-full lg:max-w-[500px] lg:min-w-[500px] h-[fit-content] max-h-full bg-white p-[15px] border rounded-[15px] relative flex flex-col scroll-container">

                        {step === 1 && (<>

                            <div className="flex justify-between items-center">
                                <h1 className="font-bold text-[20px]">
                                    {params.title === "outstation" ? t("City to city") : params.title === "hourly-rental" ? t("Rental") : t("Freight")}
                                </h1>

                                <button
                                    onClick={addStop}
                                    className="border px-3 py-1 rounded-full text-sm"
                                >
                                    {t("+ Add stop")}
                                </button>
                            </div>

                            <div>

                                <div className="my-4 space-y-3 max-h-full scroll-container">
                                    <LocationInput
                                        value={pickupLocation?.subt || pickupLocation?.title}
                                        placeholder={t("Pickup location")}
                                        color="location-icon-green"
                                        onClick={() => setShowModel("Pickup")}
                                        onClear={() => setPickupLocation(null)}
                                    />
                                    {stopList.map((stop, index) => (
                                        <div key={index} className="flex gap-2 items-center">
                                            <div className="flex-1">
                                                <LocationInput
                                                    value={stop?.subt || stop?.title}
                                                    placeholder={t("Stop location")}
                                                    color="location-icon-yellow"
                                                    onClick={() => { setSelectedStopIndex(index); setShowModel("Stop"); }}
                                                    onClear={() => removeStop(index)}
                                                />
                                            </div>
                                            <div className="flex flex-col justify-center gap-0.5">
                                                <button
                                                    onClick={() => moveStopUp(index)}
                                                    disabled={index === 0}
                                                    className={`p-1 rounded hover:bg-gray-150 ${index === 0 ? "opacity-30 cursor-not-allowed" : ""}`}
                                                    type="button"
                                                    title="Move Up"
                                                >
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 4L4 12H9V20H15V12H20L12 4Z" fill="currentColor" className="text-gray-500" />
                                                    </svg>
                                                </button>
                                                <button
                                                    onClick={() => moveStopDown(index)}
                                                    disabled={index === stopList.length - 1}
                                                    className={`p-1 rounded hover:bg-gray-150 ${index === stopList.length - 1 ? "opacity-30 cursor-not-allowed" : ""}`}
                                                    type="button"
                                                    title="Move Down"
                                                >
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 20L20 12H15V4H9V12H4L12 20Z" fill="currentColor" className="text-gray-500" />
                                                    </svg>
                                                </button>
                                            </div>
                                            <button onClick={() => removeStop(index)} className="flex items-center justify-center p-1 rounded hover:bg-gray-150">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path className="text-gray-200" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor" />
                                                    <path d="M13.061 12L15.531 9.53005C15.824 9.23705 15.824 8.76202 15.531 8.46902C15.238 8.17602 14.763 8.17602 14.47 8.46902L12 10.939L9.52999 8.46902C9.23699 8.17602 8.76199 8.17602 8.46899 8.46902C8.17599 8.76202 8.17599 9.23705 8.46899 9.53005L10.939 12L8.46899 14.47C8.17599 14.763 8.17599 15.238 8.46899 15.531C8.61499 15.677 8.80699 15.751 8.99899 15.751C9.19099 15.751 9.38298 15.678 9.52898 15.531L11.999 13.061L14.469 15.531C14.615 15.677 14.807 15.751 14.999 15.751C15.191 15.751 15.383 15.678 15.529 15.531C15.822 15.238 15.822 14.763 15.529 14.47L13.061 12Z" fill="currentColor" />
                                                </svg>
                                            </button>
                                        </div>
                                    ))}
                                    <LocationInput
                                        value={dropLocation?.subt || dropLocation?.title}
                                        placeholder={t("Dropoff location")}
                                        color="location-icon-red"
                                        onClick={() => setShowModel("Drop")}
                                        onClear={() => setDropLocation(null)}
                                    />
                                </div>

                                {params.title === "outstation" && <Outstation pickupLocation={pickupLocation} stopList={stopList} dropLocation={dropLocation} setModelData={setModelData}
                                    setShowModel={setShowModel} date={selectDate} time={selectTime} setFareCalculate={setFareCalculate} />}

                                {params.title === "hourly-rental" && <HourlyRental pickupLocation={pickupLocation} dropLocation={dropLocation} setModelData={setModelData}
                                    setShowModel={setShowModel} date={selectDate} time={selectTime} stopList={stopList} setFareCalculate={setFareCalculate} />}

                                {params.title === "package" && <Package pickupLocation={pickupLocation} dropLocation={dropLocation} setModelData={setModelData}
                                    setShowModel={setShowModel} date={selectDate} time={selectTime} stopList={stopList} setFareCalculate={setFareCalculate} packageData={packageData} />}

                            </div>
                        </>)}

                        {step === 2 && (
                            <>
                                <h1 className="font-bold text-[20px]">
                                    {t("Choose your pickup spot")}
                                </h1>

                                <p className="text-[17px] my-2">{currentads?.name}</p>

                                <button onClick={() => { setStep(1); handleSelectLocation(currentads); }} className="h-12 w-full rounded-[8px] mt-2 bg-[--bg-color] italic hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-transform active:scale-95">
                                    {t("Confirm pickup")}
                                </button>

                                <button
                                    onClick={() => setStep(1)}
                                    className="h-12 w-full rounded-[8px] border border-[--bg-color] mt-3 italic text-[--bg-color] tracking-[1px] font-bold transition-transform active:scale-95"
                                >
                                    {t("Cancel")}
                                </button>
                            </>
                        )}

                    </div>

                    <div className="w-full h-[500px] lg:h-full relative rounded-[15px] overflow-hidden">
                        <Map pickupLocation={pickupLocation} dropLocation={dropLocation} stopList={stopList} step={step} HandleGetGoogleAddress={HandleGetGoogleAddress}
                            categoryData={[]} />
                    </div>

                </div>
            </div>

            <AnimatePresence initial={false}>
                {(showModel === "Pickup" || showModel === "Drop" || showModel === "Stop") && (
                    <div className="model items-center">

                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 30 }}
                            className="bg-white w-[450px] rounded-[15px] overflow-hidden"
                        >
                            <div className="px-5 py-2">
                                <div className="flex items-center justify-between">
                                    <h1 className='font-medium text-[20px]'>{t("Location search")}</h1>
                                    <button onClick={closeModal} className='hover:bg-gray-100 rounded-full p-2'>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" />
                                        </svg>
                                    </button>
                                </div>

                                <div className="relative mt-3">
                                    <input
                                        ref={searchRef}
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        placeholder={t("Search location")}
                                        className="w-full border-2 pl-3 pr-10 py-2 rounded-lg outline-[--bg-color]"
                                    />
                                    {searchText && (
                                        <button
                                            onClick={() => setSearchText("")}
                                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-650"
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </button>
                                    )}
                                </div>
                            </div>

                            {apiLoading === "Location" ? (
                                <div className="h-[300px]">
                                    <BtnLoader CustomeStyle={"bg-[--bg-color]"} />
                                </div>
                            ) : (
                                <div className="max-h-[70vh] scroll-container py-2">
                                    {/* Allow Location Access Option */}
                                    <div onClick={handleGetCurrentLocation} className="px-[20px] py-3 hover:bg-gray-150 cursor-pointer flex items-center gap-3 border-b border-gray-100">
                                        <div className="max-w-[40px] min-w-[40px] h-[40px] bg-black rounded-full flex items-center justify-center text-white">
                                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" fill="currentColor"/>
                                                <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2"/>
                                                <line x1="12" y1="2" x2="12" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                <line x1="12" y1="20" x2="12" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                <line x1="2" y1="12" x2="4" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                <line x1="20" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                            </svg>
                                        </div>
                                        <div className="flex flex-col justify-center flex-grow min-w-0 text-start leading-5">
                                            <h1 className='font-semibold text-gray-900 text-sm leading-tight'>{t("Allow location access")}</h1>
                                            <p className='text-xs text-blue-500 mt-1'>{t("It provides your pickup address")}</p>
                                        </div>
                                    </div>

                                    <div onClick={() => { setShowModel(""); setStep(step + 1) }} className="px-[20px] py-3 hover:bg-gray-150 cursor-pointer flex items-center gap-3">
                                        <div className="max-w-[40px] min-w-[40px] h-[40px] bg-gray-200 rounded-full flex items-center text-black justify-center">
                                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"><g fill="currentColor"><path d="M11.999 9.87a1.686 1.686 0 1 0 0-3.37c-.93 0-1.69.76-1.69 1.69 0 .93.76 1.68 1.69 1.68Z"></path><path fillRule="evenodd" clipRule="evenodd" d="M1 23V1h22v17H7l-5 5H1Zm11-8.1 3.36-3.36a4.74 4.74 0 0 0 0-6.71 4.753 4.753 0 0 0-6.72 0 4.75 4.75 0 0 0 0 6.71L12 14.9Z"></path></g></svg>
                                        </div>
                                        <div className="flex flex-col justify-center flex-grow min-w-0 text-start">
                                            <h1 className='font-semibold text-gray-900 text-sm leading-tight'>{t("Set location on map")}</h1>
                                        </div>
                                    </div>

                                    

                                    {searchText.length === 0 && (() => {
                                        const rawRecents = localStorage.getItem("recent_searches");
                                        const recents = rawRecents ? JSON.parse(rawRecents) : [];
                                        if (recents.length === 0) return null;
                                        return (
                                            <div>
                                                <h3 className="px-5 pt-3 pb-1 text-xs font-bold text-gray-400 uppercase tracking-wider text-start">{t("Recent Searches")}</h3>
                                                {recents.map((item, idx) => (
                                                    <div
                                                        key={`recent-${idx}`}
                                                        className="px-5 py-2 hover:bg-gray-150 cursor-pointer flex items-center justify-between group"
                                                    >
                                                        <div
                                                            onClick={() => {
                                                                const placeData = {
                                                                    name: item.title,
                                                                    formatted_address: item.subt,
                                                                    geometry: {
                                                                        location: {
                                                                            lat: item.lat,
                                                                            lng: item.lng
                                                                        }
                                                                    }
                                                                };
                                                                handleSelectLocation(placeData);
                                                            }}
                                                            className="flex items-center gap-3 flex-grow text-start min-w-0"
                                                        >
                                                            <div className="max-w-[40px] min-w-[40px] h-[40px] bg-gray-200 rounded-full flex items-center text-gray-600 justify-center">
                                                                <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                                                            </div>
                                                            <div className="flex flex-col justify-center flex-grow min-w-0">
                                                                <h1 className="font-semibold text-gray-700 text-sm leading-tight truncate">{item.title}</h1>
                                                                <p className="text-xs text-gray-500 line-clamp-1 mt-1 truncate">{item.subt}</p>
                                                            </div>
                                                        </div>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                const rawRecents = localStorage.getItem("recent_searches");
                                                                let recentsList = rawRecents ? JSON.parse(rawRecents) : [];
                                                                recentsList = recentsList.filter(r => r.title !== item.title || r.subt !== item.subt);
                                                                localStorage.setItem("recent_searches", JSON.stringify(recentsList));
                                                                setRecentUpdateTrigger(prev => prev + 1);
                                                            }}
                                                            className="text-gray-400 hover:text-red-500 p-2 ml-2 flex-shrink-0"
                                                            title={t("Delete")}
                                                        >
                                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })()}

                                    {searchText.length > 0 && searchData.map((item, index) => (
                                        <div
                                            key={index}
                                            onClick={() => handleSelectLocation(item)}
                                            className="px-5 py-3 hover:bg-gray-150 cursor-pointer flex items-center gap-3"
                                        >
                                            <div className="max-w-[40px] min-w-[40px] h-[40px] bg-gray-200 rounded-full flex items-center text-black justify-center">
                                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path d="M18.7 3.8C15 .1 9 .1 5.3 3.8c-3.7 3.7-3.7 9.8 0 13.5L12 24l6.7-6.8c3.7-3.6 3.7-9.7 0-13.4ZM12 12.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z" fill="currentColor"></path></svg>                                            </div>
                                            <div className="text-start leading-5">
                                                <h1 className="font-semibold text-gray-900">{item.name}</h1>
                                                <p className="text-sm text-gray-600 line-clamp-2">
                                                    {item.formatted_address}
                                                </p>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            )}
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Cat-Detail" && (
                    <div className="model items-center">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 20 }}
                            className="bg-white w-[400px] p-4 rounded-[15px] relative space-y-3"
                        >
                            <button onClick={() => setShowModel("")} className="absolute -top-3 -right-3 bg-[--bg-color] p-[5px] rounded-full">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="white" />
                                </svg>
                            </button>

                            <ImageLoad src={BaseUrl + modelData.image} CustomeStyle={"w-[120px] h-[120px] mx-auto"} ImagStyle={"w-full h-full object-cover"} alt={modelData?.title || modelData?.name} status={false} />
                            <h1 className="font-semibold text-[20px] text-center">{modelData?.title || modelData?.name}</h1>
                            <p className="text-[15px] text-center leading-5">{modelData?.description}</p>

                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Date" && (
                    <div className="model items-center">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 20 }}
                            className=""
                        >
                            <DatePicker value={selectDate} setIsDate={setShowModel} handleDateChange={handleDateChange} disabled={""} />
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Time" && (
                    <div className="model items-center">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 20 }}
                            className=""
                        >
                            <TimePicker value={selectTime} setIsTime={setShowModel} handleTimeSelect={handleTimeSelect} />
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "FareCalculate" && (
                    <div className="model items-center">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 20 }}
                            className="bg-white w-[450px] p-4 rounded-[15px] relative space-y-3">

                            <div className="flex items-center justify-between">
                                <h1 className="font-semibold">{t("Recommended fare")}</h1>
                                <button onClick={() => setShowModel("")}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="black" />
                                    </svg>
                                </button>
                            </div>

                            <div className="space-y-1.5 py-1">
                                {[{ id: 1, title: "Total Km", value: fareCalculate?.tot_km },
                                { id: 2, title: "Total Hours", value: fareCalculate?.tot_hour },
                                { id: 3, title: "Total Minutes", value: fareCalculate?.tot_minute },
                                { id: 4, title: "Extra Charge", value: fareCalculate?.extra_charge },
                                { id: 5, title: "Weather Charge", value: fareCalculate?.weather_charge },
                                { id: 6, title: "Extra Person Charge", value: fareCalculate?.extra_person_charge },
                                { id: 7, title: "Day Charge", value: fareCalculate?.day_charge },
                                { id: 8, title: "Per Hours Charge x 1", value: fareCalculate?.hour_charge },
                                { id: 9, title: "Per Hours Discount", value: fareCalculate?.per_hour_discount },
                                { id: 10, title: "Km Charge", value: fareCalculate?.km_charge },
                                { id: 11, title: "Kg Charge", value: fareCalculate?.kg_charge },
                                { id: 12, title: "Platform Fee", value: fareCalculate?.site_commission },
                                ].map((item, index) => {
                                    const IsShow = params.title === "outstation" ? [1, 2, 3, 4, 5, 6, 7, 12].includes(item.id)
                                        : params.title === "hourly-rental" ? [1, 2, 3, 4, 5, 8, 9, 12].includes(item.id)
                                            : [1, 2, 3, 4, 5, 10, 11, 12].includes(item.id);
                                    if (IsShow) {
                                        return <div key={index} className="flex items-center justify-between py-0.5 relative group">
                                            <div className="flex items-center gap-1.5">
                                                <p className="text-gray-700 text-sm font-medium">{t(item.title)}</p>
                                                <div className="relative flex items-center justify-center cursor-help text-gray-400 hover:text-gray-600 transition-colors">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"/>
                                                        <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        <circle cx="12" cy="8" r="1.5" fill="currentColor"/>
                                                    </svg>
                                                    <div className="pointer-events-none opacity-0 group-hover:opacity-100 absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 w-64 p-2 bg-gray-900 text-white text-[11px] rounded-lg shadow-xl transition-all duration-200 z-50 text-center font-normal leading-relaxed">
                                                        {getTooltipText(item.id, fareCalculate, currency)}
                                                        <div className="w-2 h-2 bg-gray-900 absolute top-full left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="text-gray-900 text-sm font-semibold">{item.id === 9 && "-"}{index >= 3 && currency}{item.value}</p>
                                        </div>
                                    }
                                })}
                            </div>

                            <div className="flex items-center justify-between border-t pt-3 font-semibold text-[17px]">
                                <p>{t("Total Price")}</p>
                                <p>{currency + fareCalculate?.tot_price}</p>
                            </div>

                            <button onClick={() => setShowModel("Price")} className="min-h-12 w-full rounded-[8px] bg-[--bg-color] italic hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-transform active:scale-95">
                                {t("Find Driver")}
                            </button>

                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Price" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] px-5 py-3 rounded-[20px] relative mx-3"
                    >
                        <PriceModel data={fareCalculate} setData={setFareCalculate} pickupLocation={pickupLocation} dropLocation={dropLocation} stopList={stopList}
                            setShowModel={setShowModel} selectPayment={selectPayment} selectCoupon={selectCoupon} setSelectCoupon={setSelectCoupon} setIsModel={setIsModel} handleCancelRequest={handleCancelRequest} handleRequestTimeOut={handleRequestTimeOut} />

                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {isModel === "Payment" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[500px] px-5 py-3 rounded-[20px] relative mx-3"
                    >
                        <Payment setIsModel={setIsModel} index={1} selectPayment={selectPayment} setSelectPayment={setSelectPayment} paymentList={paymentList} Data={null} Amount={0} />
                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {isModel === "Coupon" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] px-5 py-3 rounded-[20px] relative mx-3"
                    >

                        <div className="flex items-center justify-between mb-2">
                            <h1 className='font-medium text-[20px]'>{t("Select Coupon")}</h1>
                            <button onClick={() => setIsModel("")} className='hover:bg-gray-100 rounded-full p-2'>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" />
                                </svg>
                            </button>
                        </div>

                        <div className="mt-2 max-h-[80vh] scroll-container">
                            {couponList.map((item, index) => {
                                const Isdisabled = item.min_amount > fareCalculate?.bid_addjust_amount;
                                const IsApply = item.id === selectCoupon?.id;
                                return <div key={index} className="border p-5 rounded-[15px] mt-3 flex items-center justify-between agp-5">
                                    <div className="leading-[22px]">
                                        <h1 className="font-bold text-[19px]">{item.title}</h1>
                                        <span className="text-gray-600">{item.sub_title}</span>
                                        <p>{t("Coupon Code")} : <span className="font-semibold text-[--bg-color]">{item.code}</span></p>
                                        <p>{t("Coupon Amount")} : <span className="font-semibold">{currency + item.discount_amount}</span></p>
                                        <p>{t("Minimum Amount")} : <span className="font-semibold">{currency + item.min_amount}</span></p>
                                        <p>{t("Ex Date")} : <span className="font-semibold">{item.end_date.split(" ")[0]}</span></p>
                                        {!IsApply
                                            ? <button disabled={Isdisabled} onClick={() => { setSelectCoupon({ id: item.id, code: item.code, amt: item.discount_amount, min: item.min_amount }); setIsModel(""); }} className={`mt-2 border ${Isdisabled ? "border-gray-400 text-gray-400" : "border-[--bg-color] text-[--bg-color] hover:bg-[--bg-color] hover:text-white hover:scale-[1.02] active:scale-[0.98]"} px-6 py-[7px] rounded-[50px] font-semibold italic transition-all duration-200`}>
                                                {t("Apply Coupon")}
                                            </button>
                                            : <button onClick={() => { setSelectCoupon(null); setIsModel(""); }} className="mt-2 border border-red-600 text-red-600 italic font-semibold px-6 py-[7px] rounded-[50px] hover:scale-[1.02] active:scale-[0.98] transition-all duration-200">
                                                {t("Remove Coupon")}
                                            </button>}
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 31 31" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M28.5187 11.0753L29.6351 12.1913C30.519 13.0593 30.9996 14.2373 30.9996 15.4773C31.0151 16.7173 30.5345 17.8969 29.6662 18.7788C29.6558 18.7902 29.6455 18.8002 29.6351 18.8102C29.63 18.8152 29.6248 18.8202 29.6196 18.8253L28.5187 19.9258C28.0846 20.3598 27.8365 20.9488 27.8365 21.5704V23.1653C27.8365 25.7383 25.7432 27.8324 23.1693 27.8324H21.5722C20.952 27.8324 20.3628 28.0788 19.9286 28.5128L18.8122 29.6288C17.8974 30.5449 16.7035 30.9928 15.5095 30.9928C14.3156 30.9928 13.1217 30.5449 12.2068 29.6459L11.0749 28.5128C10.6408 28.0788 10.0515 27.8324 9.43132 27.8324H7.83424C5.26031 27.8324 3.16705 25.7383 3.16705 23.1653V21.5704C3.16705 20.9488 2.91896 20.3598 2.4848 19.9103L1.3684 18.8098C-0.445762 16.9979 -0.461267 14.0358 1.35289 12.2084L2.4848 11.0753C2.91896 10.6413 3.16705 10.0523 3.16705 9.41684V7.83584C3.16705 5.26284 5.26031 3.17189 7.83424 3.17189H9.43132C10.0515 3.17189 10.6408 2.92234 11.0749 2.48834L12.1913 1.37234C14.0055 -0.455114 16.967 -0.455114 18.7967 1.35839L19.9286 2.48834C20.3628 2.92234 20.952 3.17189 21.5722 3.17189H23.1693C25.7432 3.17189 27.8365 5.26284 27.8365 7.83584V9.43389C27.8365 10.0523 28.0846 10.6413 28.5187 11.0753ZM11.511 20.8407C11.8831 20.8407 12.2242 20.7012 12.4723 20.4377L20.4422 12.4723C20.9694 11.9453 20.9694 11.0757 20.4422 10.5487C19.915 10.0233 19.0622 10.0233 18.535 10.5487L10.5651 18.5157C10.0379 19.0427 10.0379 19.9107 10.5651 20.4377C10.8132 20.7012 11.1543 20.8407 11.511 20.8407ZM18.1316 19.4764C18.1316 20.2359 18.7364 20.8404 19.4961 20.8404C20.2404 20.8404 20.8451 20.2359 20.8451 19.4764C20.8451 18.734 20.2404 18.1279 19.4961 18.1279C18.7364 18.1279 18.1316 18.734 18.1316 19.4764ZM11.5243 10.1605C12.2685 10.1605 12.8732 10.765 12.8732 11.509C12.8732 12.2701 12.2685 12.873 11.5243 12.873C10.78 12.873 10.1598 12.2701 10.1598 11.509C10.1598 10.765 10.78 10.1605 11.5243 10.1605Z" fill="#FFB733" />
                                    </svg>
                                </div>
                            })}
                        </div>

                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Busy" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] px-5 py-3 rounded-[20px] relative mx-3"
                    >

                        <div className="flex items-center justify-between">
                            <h1 className='font-medium text-[20px]'>{t("Captains are busy")}</h1>
                            <button onClick={() => setShowModel("")} className='hover:bg-gray-100 rounded-full p-2'>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" />
                                </svg>
                            </button>
                        </div>

                        <div className="flex items-stretch gap-4 py-5">
                            <div className="flex flex-col items-center justify-center gap-6">
                                <div className="location-icon-green"></div>
                                <span className="rotate-90 w-[35px] border-t-[2px] border-gray-400 border-dashed"></span>
                                <div className="location-icon-red"></div>
                            </div>
                            <div className="flex flex-col gap-2">
                                <div>
                                    <h1 className="font-semibold text-[17px] line-clamp-2">{pickupLocation?.title}</h1>
                                    <p className="text-[15px] leading-5 text-gray-700 line-clamp-2">{pickupLocation?.subt}</p>
                                </div>
                                <div>
                                    <h1 className="font-semibold text-[17px] line-clamp-2">{dropLocation?.title}</h1>
                                    <p className="text-[15px] leading-5 text-gray-700 line-clamp-2">{dropLocation?.subt}</p>
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center gap-3">
                            <button onClick={() => setShowModel("")} className="h-10 w-full rounded-[8px] bg-[--bg-color] italic hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-transform">{t("Try Again")}</button>
                            <button onClick={handleCancelRequest} className="h-10 w-full rounded-[8px] border border-[--bg-color] italic tracking-[1px] text-[--bg-color] font-bold">{t("Cancel")}</button>
                        </div>

                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Package" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] px-5 py-3 rounded-[20px] relative mx-3"
                    >

                        <div className="flex items-center justify-between mb-3">
                            <h1 className='font-semibold text-[20px] flex items-center gap-2'><span>📦</span> {t("Package details")}</h1>
                            <button onClick={() => setShowModel("")} className='hover:bg-gray-100 rounded-full p-2 transition-colors'>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" />
                                </svg>
                            </button>
                        </div>

                        <form onSubmit={(e) => { e.preventDefault(); setShowModel(""); }} className="mt-2 space-y-4">

                            <div>
                                <label className="text-sm font-medium text-gray-600 mb-1 block flex items-center gap-1.5"><span>⚖️</span> {t("Package Weight")}</label>
                                <div className="relative">
                                    <input type="number" value={packageData?.kg} required onChange={handleChange} className='w-full px-3 py-2.5 pr-12 rounded-[10px] outline-[--bg-color] border border-gray-200 bg-gray-50 focus:bg-white focus:border-[--bg-color] transition-all' placeholder={t("total_kg_placeholder", { kg: modelData?.num_of_kg })} />
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-medium text-gray-400">kg</span>
                                </div>
                            </div>

                            <div>
                                <label className="text-sm font-medium text-gray-600 mb-1 block flex items-center gap-1.5"><span>📏</span> {t("Package Dimensions")}</label>
                                <div className="flex items-center gap-3">
                                    <div className="relative flex-1">
                                        <input type="number" required value={packageData.length} onChange={(e) => setPackageData({ ...packageData, length: e.target.value })} className='w-full px-3 py-2.5 pr-8 rounded-[10px] outline-[--bg-color] border border-gray-200 bg-gray-50 focus:bg-white focus:border-[--bg-color] transition-all' placeholder={t("Length")} />
                                        <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs font-medium text-gray-400">ft</span>
                                    </div>
                                    <span className="text-gray-300 font-light">×</span>
                                    <div className="relative flex-1">
                                        <input type="number" required value={packageData.weight} onChange={(e) => setPackageData({ ...packageData, weight: e.target.value })} className='w-full px-3 py-2.5 pr-8 rounded-[10px] outline-[--bg-color] border border-gray-200 bg-gray-50 focus:bg-white focus:border-[--bg-color] transition-all' placeholder={t("Width")} />
                                        <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs font-medium text-gray-400">ft</span>
                                    </div>
                                    <span className="text-gray-300 font-light">×</span>
                                    <div className="relative flex-1">
                                        <input type="number" required value={packageData.height} onChange={(e) => setPackageData({ ...packageData, height: e.target.value })} className='w-full px-3 py-2.5 pr-8 rounded-[10px] outline-[--bg-color] border border-gray-200 bg-gray-50 focus:bg-white focus:border-[--bg-color] transition-all' placeholder={t("Height")} />
                                        <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs font-medium text-gray-400">ft</span>
                                    </div>
                                </div>
                            </div>

                            <div className="border-t border-gray-100 pt-3">
                                <label className='text-sm font-medium text-gray-600 mb-1 block flex items-center gap-1.5'><span>📝</span> {t("What to deliver")}</label>
                                <textarea required value={packageData.desc} onChange={(e) => setPackageData({ ...packageData, desc: e.target.value })} className='w-full h-[90px] resize-none px-3 py-2.5 rounded-[10px] outline-[--bg-color] border border-gray-200 bg-gray-50 focus:bg-white focus:border-[--bg-color] transition-all' placeholder={t('For example: a small box, about 1kg')}></textarea>
                            </div>

                            <button type='submit' className="min-h-11 w-full mt-2 rounded-[10px] bg-[--bg-color] hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-all active:scale-95 flex items-center justify-center gap-2">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.86 18.75C9.668 18.75 9.48399 18.676 9.34399 18.543L4.34399 13.793C4.04599 13.509 4.035 13.034 4.319 12.736C4.603 12.437 5.078 12.427 5.376 12.711L9.843 16.953L18.609 7.47302C18.884 7.16602 19.358 7.14001 19.665 7.41401C19.972 7.68801 19.998 8.163 19.724 8.47L10.394 18.524C10.256 18.678 10.063 18.766 9.857 18.775L9.86 18.75Z" fill="white" /></svg>
                                {t("Save Package Details")}
                            </button>

                        </form>

                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Login" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] px-5 py-3 rounded-[20px] space-y-4 mx-3"
                    >
                        <h1 className='font-medium text-[20px]'>{t("Log in to see ride options")}</h1>
                        <p className="text-[17px] leading-5">{t("Please take a moment to quickly log in or sign up so we can show you your ride options")}</p>
                        <button onClick={() => navigate("/auth/login-signup")} className="min-h-10 w-full rounded-[8px] bg-[--bg-color] italic hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-transform active:scale-95">
                            {t("Continue")}
                        </button>
                    </motion.div>
                </div>}
            </AnimatePresence>

            <PageLoader loading={loading} />

        </div>
    )
}

export default Category

const Outstation = ({ pickupLocation, dropLocation, stopList, setModelData, setShowModel, date, time, setFareCalculate }) => {
    const { t } = useTranslation();
    const { BaseUrl, isAuth, handleCallApi, setShowToast, setToastMsg } = useContext(MyContext);

    const [apiLoading, setApiLoading] = useState("");
    const [categoryList, setCategoryList] = useState([]);
    const [selectRide, setSelectRide] = useState("");
    const [servicesList, setServicesList] = useState([]);
    const [selectService, setSelectService] = useState("");
    const [vehicleList, setVehicleList] = useState([]);
    const [selectVehicle, setSelectVehicle] = useState("");
    const [number, setNumber] = useState(1);

    const FetchRef = useRef(false);
    const Location = useLocation();

    useEffect(() => {
        if (FetchRef.current) return;
        FetchRef.current = true;
        handleFetchCategory();
    }, []);

    const handleFetchCategory = async () => {
        const Response = await handleCallApi("Get", "cus_outs/category_detail");
        setCategoryList(Response.data?.category);
    }

    const handleSelectItem = async (index, item) => {

        if (!pickupLocation) {
            setShowToast(true);
            setToastMsg("Please select pickup location !!");
            return;
        }

        if (!dropLocation) {
            setShowToast(true);
            setToastMsg("Please select dropoff location !!");
            return;
        }

        if (!isAuth) {
            setShowModel("Login");
            return;
        }

        if (index === 1) {
            setSelectRide(item);
            handleFetchservices(item.id);
            setSelectService("");
            setSelectVehicle("");
        }

        if (index === 2) {
            setSelectService(item);
            handleFetchVehicle(item.id);
            setNumber(1);
            setSelectVehicle("");
        }

        if (index === 3) {
            setSelectVehicle(item);
        }

    }

    const handleFetchservices = async (cat_id) => {
        setApiLoading(`Category-${cat_id}`);
        const Response = await handleCallApi("Post", "cus_outs/outstation_list", { cat_id });
        setServicesList(Response.data.outstation);
        setApiLoading("");
    }

    const handleFetchVehicle = async (outs_id) => {
        setApiLoading(`Service-${outs_id}`);
        const Response = await handleCallApi("Post", "cus_outs/vehicle_list", { outs_id });
        setVehicleList(Response.data.vehicle);
        setApiLoading("");
    }

    const hnadleFareCount = async () => {

        if (!pickupLocation) {
            setShowToast(true);
            setToastMsg("Please select pickup location !!");
            return;
        }

        if (!dropLocation) {
            setShowToast(true);
            setToastMsg("Please select dropoff location !!");
            return;
        }

        if (!selectRide) {
            setShowToast(true);
            setToastMsg(t("Please select a ride type !!"));
            return;
        }

        if (!selectService) {
            setShowToast(true);
            setToastMsg(t("Please select an outstation service !!"));
            return;
        }

        if (!selectVehicle) {
            setShowToast(true);
            setToastMsg(t("Please select a vehicle type !!"));
            return;
        }

        if (!date) {
            setShowToast(true);
            setToastMsg(t("Please select a booking date !!"));
            return;
        }

        if (!time) {
            setShowToast(true);
            setToastMsg(t("Please select a booking time !!"));
            return;
        }

        const hasEmptyStop = stopList.some(item => !item || !item.lat || !item.lng);
        if (hasEmptyStop) {
            setShowToast(true);
            setToastMsg("Please fill all stop locations !!");
            return;
        }

        const DropList = stopList?.map((item) => item && ({ lat: item?.lat, long: item?.lng }));
        const ApiBody = {
            outs_id: selectService?.id,
            vehicle_id: selectVehicle?.id,
            num_passenger: number,
            book_date: date?.format("YYYY-MM-DD"),
            pickup_lat_lon: `${pickupLocation?.lat},${pickupLocation?.lng}`,
            drop_lat_lon: `${dropLocation?.lat},${dropLocation?.lng}`,
            drop_lat_lon_list: DropList || []
        }

        setApiLoading("fare_calculate");
        const Response = await handleCallApi("Post", "cus_outs/fare_calculate", ApiBody);
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            const Object = {
                ...selectService,
                ...Response.data,
                bid_addjust_amount: Response.data?.tot_price,
                outs_category_id: selectRide?.id,
                outs_id: selectService?.id,
                vehicle_id: selectVehicle?.id,
                num_passenger: number,
                book_date: date.format("YYYY-MM-DD"),
                book_time: time.format('hh:mm A'),
                m_role: Location.state
            };
            setFareCalculate(Object);
            setShowModel("FareCalculate");
        }
        setApiLoading("");
    }

    const handleIncrement = () => {
        if (selectService?.passenger_capacity === number) {
            setShowToast(true);
            setToastMsg(t("max_passenger", { count: selectService?.passenger_capacity }));
            return;
        }
        setNumber(number + 1);
    }

    return <>

        <div>
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>🚗</span> {t("Select Ride Type")}</h1>
            <Swiper
                slidesPerView={"auto"}
                spaceBetween={10}
                modules={[Navigation]}
                className="mySwiper">
                {categoryList.map((item, index) => {
                    const isSelected = item.id === selectRide?.id;
                    const IsLoading = `Category-${item.id}` == apiLoading;
                    return <SwiperSlide key={index} onClick={() => handleSelectItem(1, item)} style={{ width: "130px" }} className={`px-3 py-4 relative ${isSelected ? "bg-[#4038ff]/10" : "bg-gray-100"} rounded-[10px] cursor-pointer`}>
                        {isSelected && <button onClick={() => { setShowModel("Cat-Detail"); setModelData(item); }} className="absolute top-[7px] right-[7px] z-30">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM12.75 16.5V11.929C12.75 11.515 12.414 11.179 12 11.179C11.586 11.179 11.25 11.515 11.25 11.929V16.5C11.25 16.914 11.586 17.25 12 17.25C12.414 17.25 12.75 16.914 12.75 16.5ZM13.02 8.5C13.02 7.948 12.573 7.5 12.02 7.5H12.01C11.458 7.5 11.0149 7.948 11.0149 8.5C11.0149 9.052 11.468 9.5 12.02 9.5C12.572 9.5 13.02 9.052 13.02 8.5Z" fill="#4038ff" />
                            </svg>
                        </button>}
                        {IsLoading
                            ? <div className="h-[50px]">
                                <BtnLoader CustomeStyle={"bg-[--bg-color]"} />
                            </div>
                            : <ImageLoad src={BaseUrl + item.image} CustomeStyle={"w-[50px] h-[50px] mx-auto"} ImagStyle={"w-full h-full object-cover"} alt={item?.title} status={false} />}
                        <h1 className="text-center mt-2 text-[15px]">{item?.title}</h1>
                    </SwiperSlide>
                })}
            </Swiper>
        </div>

        {servicesList.length >= 1 && <div className="mt-3">
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>🛣️</span> {t("Select Outstation Services")}</h1>

            <Swiper
                slidesPerView={"auto"}
                spaceBetween={10}
                modules={[Navigation]}
                className="mySwiper">
                {servicesList.map((item, index) => {
                    const isSelected = item.id === selectService?.id;
                    const IsLoading = `Service-${item.id}` == apiLoading;
                    return <SwiperSlide key={index} onClick={() => handleSelectItem(2, item)} style={{ width: "fit-content" }} className={`px-3 py-[6px] relative ${isSelected ? "bg-[#4038ff]/10" : "bg-gray-100"} rounded-[50px] cursor-pointer`}>
                        {IsLoading
                            ? <BtnLoader CustomeStyle={"bg-[--bg-color]"} />
                            : <div className="flex items-center gap-2">
                                <ImageLoad src={BaseUrl + item.image} CustomeStyle={"w-[35px] h-[35px] mx-auto"} ImagStyle={"w-full h-full object-cover"} alt={item?.name} status={false} />
                                <h1 className="text-[15px]">{item?.name}</h1>
                            </div>}
                    </SwiperSlide>
                })}
            </Swiper>
        </div>}

        {vehicleList.length >= 1 && <div className="mt-3">
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>🚙</span> {t("Available Vehicle Types")}</h1>

            <Swiper
                slidesPerView={"auto"}
                spaceBetween={10}
                modules={[Navigation]}
                className="mySwiper">
                {vehicleList.map((item, index) => {
                    const isSelected = item.id === selectVehicle?.id;
                    return <SwiperSlide key={index} onClick={() => handleSelectItem(3, item)} style={{ width: "130px" }} className={`px-3 py-4 relative ${isSelected ? "bg-[#4038ff]/10" : "bg-gray-100"} rounded-[10px] cursor-pointer`}>
                        {isSelected && <button onClick={() => { setShowModel("Cat-Detail"); setModelData(item); }} className="absolute top-[7px] right-[7px] z-30">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM12.75 16.5V11.929C12.75 11.515 12.414 11.179 12 11.179C11.586 11.179 11.25 11.515 11.25 11.929V16.5C11.25 16.914 11.586 17.25 12 17.25C12.414 17.25 12.75 16.914 12.75 16.5ZM13.02 8.5C13.02 7.948 12.573 7.5 12.02 7.5H12.01C11.458 7.5 11.0149 7.948 11.0149 8.5C11.0149 9.052 11.468 9.5 12.02 9.5C12.572 9.5 13.02 9.052 13.02 8.5Z" fill="#4038ff" />
                            </svg>
                        </button>}
                        <ImageLoad src={BaseUrl + item.image} CustomeStyle={"w-[50px] h-[50px] mx-auto"} ImagStyle={"w-full h-full object-cover"} alt={item?.name} status={false} />
                        <h1 className="text-center mt-2 text-[15px]">{item?.name}</h1>
                    </SwiperSlide>
                })}
            </Swiper>
        </div>}

        <div className="mt-3">
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>📅</span> {t("Select Date & Time")}</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div onClick={() => setShowModel("Date")} className={`flex items-center justify-between border p-2 rounded-[10px] cursor-pointer transition-all ${date ? 'border-[--bg-color] text-[--bg-color]' : 'border-gray-200 text-gray-400'}`}>
                    <h1>{date ? date?.format("YYYY-MM-DD") : t("Select date")}</h1>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 3.75H16.75V3C16.75 2.586 16.414 2.25 16 2.25C15.586 2.25 15.25 2.586 15.25 3V3.75H8.75V3C8.75 2.586 8.414 2.25 8 2.25C7.586 2.25 7.25 2.586 7.25 3V3.75H6C3.582 3.75 2.25 5.082 2.25 7.5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V7.5C21.75 5.082 20.418 3.75 18 3.75ZM6 5.25H7.25V6C7.25 6.414 7.586 6.75 8 6.75C8.414 6.75 8.75 6.414 8.75 6V5.25H15.25V6C15.25 6.414 15.586 6.75 16 6.75C16.414 6.75 16.75 6.414 16.75 6V5.25H18C19.577 5.25 20.25 5.923 20.25 7.5V8.25H3.75V7.5C3.75 5.923 4.423 5.25 6 5.25ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V9.75H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM9.02002 13C9.02002 13.552 8.57302 14 8.02002 14C7.46802 14 7.01489 13.552 7.01489 13C7.01489 12.448 7.45801 12 8.01001 12H8.02002C8.57202 12 9.02002 12.448 9.02002 13ZM13.02 13C13.02 13.552 12.573 14 12.02 14C11.468 14 11.0149 13.552 11.0149 13C11.0149 12.448 11.458 12 12.01 12H12.02C12.572 12 13.02 12.448 13.02 13ZM17.02 13C17.02 13.552 16.573 14 16.02 14C15.468 14 15.0149 13.552 15.0149 13C15.0149 12.448 15.458 12 16.01 12H16.02C16.572 12 17.02 12.448 17.02 13ZM9.02002 17C9.02002 17.552 8.57302 18 8.02002 18C7.46802 18 7.01489 17.552 7.01489 17C7.01489 16.448 7.45801 16 8.01001 16H8.02002C8.57202 16 9.02002 16.448 9.02002 17ZM13.02 17C13.02 17.552 12.573 18 12.02 18C11.468 18 11.0149 17.552 11.0149 17C11.0149 16.448 11.458 16 12.01 16H12.02C12.572 16 13.02 16.448 13.02 17ZM17.02 17C17.02 17.552 16.573 18 16.02 18C15.468 18 15.0149 17.552 15.0149 17C15.0149 16.448 15.458 16 16.01 16H16.02C16.572 16 17.02 16.448 17.02 17Z" fill="currentColor" />
                    </svg>
                </div>
                <div onClick={() => setShowModel("Time")} className={`flex items-center justify-between border p-2 rounded-[10px] cursor-pointer transition-all ${time ? 'border-[--bg-color] text-[--bg-color]' : 'border-gray-200 text-gray-400'}`}>
                    <h1>{time ? time?.format('hh:mm A') : t("Select time")}</h1>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM15.53 14.47C15.823 14.763 15.823 15.238 15.53 15.531C15.384 15.677 15.192 15.751 15 15.751C14.808 15.751 14.616 15.678 14.47 15.531L11.47 12.531C11.329 12.39 11.25 12.199 11.25 12.001V7.00098C11.25 6.58698 11.586 6.25098 12 6.25098C12.414 6.25098 12.75 6.58698 12.75 7.00098V11.6899L15.53 14.47Z" fill="currentColor" />
                    </svg>
                </div>
            </div>
        </div>

        <div className="mt-3">
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>👥</span> {t("Number of passengers")}</h1>
            <div className="flex items-center justify-center gap-5 py-2">
                <button disabled={number === 1} onClick={() => setNumber(number - 1)} className={`w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all ${number === 1 ? 'border-gray-200 text-gray-300 cursor-not-allowed' : 'border-[--bg-color] text-[--bg-color] hover:bg-[--bg-color] hover:text-white'}`}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12.75H5C4.586 12.75 4.25 12.414 4.25 12C4.25 11.586 4.586 11.25 5 11.25H19C19.414 11.25 19.75 11.586 19.75 12C19.75 12.414 19.414 12.75 19 12.75Z" fill="currentColor" />
                    </svg>
                </button>
                <span className='text-center font-bold text-[24px] min-w-[50px]'>{number}</span>
                <button onClick={handleIncrement} className="w-10 h-10 rounded-full border-2 border-[--bg-color] text-[--bg-color] hover:bg-[--bg-color] hover:text-white flex items-center justify-center transition-all">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.75 12C19.75 12.414 19.414 12.75 19 12.75H12.75V19C12.75 19.414 12.414 19.75 12 19.75C11.586 19.75 11.25 19.414 11.25 19V12.75H5C4.586 12.75 4.25 12.414 4.25 12C4.25 11.586 4.586 11.25 5 11.25H11.25V5C11.25 4.586 11.586 4.25 12 4.25C12.414 4.25 12.75 4.586 12.75 5V11.25H19C19.414 11.25 19.75 11.586 19.75 12Z" fill="currentColor" />
                    </svg>
                </button>
            </div>
        </div>

        <button onClick={hnadleFareCount} className="min-h-12 w-full mt-3 rounded-[10px] bg-[--bg-color] hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-all active:scale-95 flex items-center justify-center gap-2">
            {apiLoading === "fare_calculate"
                ? <BtnLoader CustomeStyle={"bg-white"} />
                : <><svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.53 20.47L17.689 16.629C19.194 14.928 20.1 12.691 20.1 10.248C20.1 4.94 15.807 0.647003 10.499 0.647003C5.191 0.647003 0.897003 4.94 0.897003 10.248C0.897003 15.556 5.191 19.849 10.499 19.849C12.727 19.849 14.784 19.1 16.422 17.837L20.47 21.885C20.617 22.032 20.808 22.105 21 22.105C21.192 22.105 21.383 22.032 21.53 21.885C21.823 21.592 21.823 21.117 21.53 20.824V20.47ZM2.647 10.248C2.647 5.905 6.156 2.397 10.499 2.397C14.842 2.397 18.35 5.905 18.35 10.248C18.35 14.591 14.842 18.099 10.499 18.099C6.156 18.099 2.647 14.591 2.647 10.248Z" fill="white" /></svg>{t("Find a driver")}</>}
        </button>

    </>
}

const HourlyRental = ({ pickupLocation, dropLocation, stopList, setModelData, setShowModel, date, time, setFareCalculate }) => {
    const { t } = useTranslation();
    const { BaseUrl, isAuth, handleCallApi, setShowToast, setToastMsg } = useContext(MyContext);

    const [apiLoading, setApiLoading] = useState("");
    const [category, setCategory] = useState([]);
    const [selectRental, setSelectRental] = useState("");
    const [vehicleList, setVehicleList] = useState([]);
    const [selectVehicle, setSelectVehicle] = useState("");
    const [hours, setHours] = useState(1);

    const FetchRef = useRef(false);
    const Location = useLocation();

    useEffect(() => {
        if (FetchRef.current) return;
        FetchRef.current = true;
        handleFetchCategory();
    }, []);

    const handleFetchCategory = async () => {
        const Response = await handleCallApi("Get", "cus_rental/rental_detail");
        setCategory(Response.data.category);
    }

    const handleSelectItem = async (index, item) => {

        if (!pickupLocation) {
            setShowToast(true);
            setToastMsg("Please select pickup location !!");
            return;
        }

        if (!dropLocation) {
            setShowToast(true);
            setToastMsg("Please select dropoff location !!");
            return;
        }

        const hasEmptyStop = stopList.some(item => !item || !item.lat || !item.lng);
        if (hasEmptyStop) {
            setShowToast(true);
            setToastMsg("Please fill all stop locations !!");
            return;
        }

        if (!isAuth) {
            setShowModel("Login");
            return;
        }

        if (index === 1) {
            setSelectRental(item);
            handleGetVehicle(item.id);
            setHours(1);
        }

        if (index === 2) {
            setSelectVehicle(item);
        }

    }

    const handleGetVehicle = async (rental_id) => {
        setApiLoading(`Type-${rental_id}`);
        const Response = await handleCallApi("Post", "cus_rental/rental_vehicle_list", { rental_id });
        setVehicleList(Response.data.vehicle);
        setApiLoading("");
    }

    const handleIncrement = () => {
        if (selectRental?.num_of_hour === hours) {
            setShowToast(true);
            setToastMsg(t("max_hours", { count: selectRental?.num_of_hour }));
            return;
        }

        setHours(hours + 1);
    }

    const handleFareCalculate = async () => {

        if (!pickupLocation) {
            setShowToast(true);
            setToastMsg("Please select pickup location !!");
            return;
        }

        if (!dropLocation) {
            setShowToast(true);
            setToastMsg("Please select dropoff location !!");
            return;
        }

        const hasEmptyStop = stopList.some(item => !item || !item.lat || !item.lng);
        if (hasEmptyStop) {
            setShowToast(true);
            setToastMsg("Please fill all stop locations !!");
            return;
        }

        if (!selectRental) {
            setShowToast(true);
            setToastMsg(t("Please select a rental type !!"));
            return;
        }

        if (!selectVehicle) {
            setShowToast(true);
            setToastMsg(t("Please select a vehicle type !!"));
            return;
        }

        if (!date) {
            setShowToast(true);
            setToastMsg(t("Please select a booking date !!"));
            return;
        }

        if (!time) {
            setShowToast(true);
            setToastMsg(t("Please select a booking time !!"));
            return;
        }

        const DropList = stopList?.map((item) => item && ({ lat: item?.lat, long: item?.lng }));
        const ApiBody = {
            rental_id: selectRental?.id,
            vehicle_id: selectVehicle?.id,
            rent_hour: hours,
            pickup_lat_lon: `${pickupLocation?.lat},${pickupLocation?.lng}`,
            drop_lat_lon: `${dropLocation?.lat},${dropLocation?.lng}`,
            drop_lat_lon_list: DropList || []
        }

        setApiLoading("Choose");
        const Response = await handleCallApi("Post", "cus_rental/rental_fare_calculate", ApiBody);
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            const Object = {
                ...selectRental,
                ...Response.data,
                bid_addjust_amount: Response.data?.tot_price,
                rent_hour: hours,
                vehicle_id: selectVehicle?.id,
                book_date: date.format("YYYY-MM-DD"),
                book_time: time.format('hh:mm A'),
                m_role: Location.state
            };
            setFareCalculate(Object);
            setShowModel("FareCalculate");
        }
        setApiLoading("");

    }

    return <>

        <div>
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>🏷️</span> {t("Rental Type")}</h1>
            <Swiper
                slidesPerView={"auto"}
                spaceBetween={10}
                modules={[Navigation]}
                className="mySwiper">
                {category.map((item, index) => {
                    const isSelected = item.id === selectRental?.id;
                    const IsLoading = `Type-${item.id}` === apiLoading;
                    return <SwiperSlide key={index} onClick={() => handleSelectItem(1, item)} style={{ width: "130px" }} className={`px-3 py-4 relative ${isSelected ? "bg-[#4038ff]/10" : "bg-gray-100"} rounded-[10px] cursor-pointer`}>
                        {isSelected && <button onClick={() => { setShowModel("Cat-Detail"); setModelData(item); }} className="absolute top-[7px] right-[7px] z-30">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM12.75 16.5V11.929C12.75 11.515 12.414 11.179 12 11.179C11.586 11.179 11.25 11.515 11.25 11.929V16.5C11.25 16.914 11.586 17.25 12 17.25C12.414 17.25 12.75 16.914 12.75 16.5ZM13.02 8.5C13.02 7.948 12.573 7.5 12.02 7.5H12.01C11.458 7.5 11.0149 7.948 11.0149 8.5C11.0149 9.052 11.468 9.5 12.02 9.5C12.572 9.5 13.02 9.052 13.02 8.5Z" fill="#4038ff" />
                            </svg>
                        </button>}
                        {IsLoading
                            ? <div className="h-[50px]">
                                <BtnLoader CustomeStyle={"bg-[--bg-color]"} />
                            </div>
                            : <ImageLoad src={BaseUrl + item.image} CustomeStyle={"w-[50px] h-[50px] mx-auto"} ImagStyle={"w-full h-full object-cover"} alt={item?.name} status={false} />}
                        <h1 className="text-center mt-2 text-[15px]">{item?.name}</h1>
                    </SwiperSlide>
                })}
            </Swiper>
        </div>

        {vehicleList.length >= 1 && <div className='mt-3'>
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>🚙</span> {t("Available Vehicle Types")}</h1>
            <Swiper
                slidesPerView={"auto"}
                spaceBetween={10}
                modules={[Navigation]}
                className="mySwiper">
                {vehicleList.map((item, index) => {
                    const isSelected = item.id === selectVehicle?.id;
                    return <SwiperSlide key={index} onClick={() => handleSelectItem(2, item)} style={{ width: "130px" }} className={`px-3 py-4 relative ${isSelected ? "bg-[#4038ff]/10" : "bg-gray-100"} rounded-[10px] cursor-pointer`}>
                        {isSelected && <button onClick={() => { setShowModel("Cat-Detail"); setModelData(item); }} className="absolute top-[7px] right-[7px] z-30">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM12.75 16.5V11.929C12.75 11.515 12.414 11.179 12 11.179C11.586 11.179 11.25 11.515 11.25 11.929V16.5C11.25 16.914 11.586 17.25 12 17.25C12.414 17.25 12.75 16.914 12.75 16.5ZM13.02 8.5C13.02 7.948 12.573 7.5 12.02 7.5H12.01C11.458 7.5 11.0149 7.948 11.0149 8.5C11.0149 9.052 11.468 9.5 12.02 9.5C12.572 9.5 13.02 9.052 13.02 8.5Z" fill="#4038ff" />
                            </svg>
                        </button>}
                        <ImageLoad src={BaseUrl + item.image} CustomeStyle={"w-[50px] h-[50px] mx-auto"} ImagStyle={"w-full h-full object-cover"} alt={item?.name} status={false} />
                        <h1 className="text-center mt-2 text-[15px]">{item?.name}</h1>
                    </SwiperSlide>
                })}
            </Swiper>
        </div>}

        {selectRental && <div className="mt-3">
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>⏱️</span> {t("How much time do you need?")}</h1>
            <div className="flex items-center justify-center gap-5 py-2">
                <button disabled={hours === 1} onClick={() => setHours(hours - 1)} className={`w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all ${hours === 1 ? 'border-gray-200 text-gray-300 cursor-not-allowed' : 'border-[--bg-color] text-[--bg-color] hover:bg-[--bg-color] hover:text-white'}`}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12.75H5C4.586 12.75 4.25 12.414 4.25 12C4.25 11.586 4.586 11.25 5 11.25H19C19.414 11.25 19.75 11.586 19.75 12C19.75 12.414 19.414 12.75 19 12.75Z" fill="currentColor" />
                    </svg>
                </button>
                <span className='text-center font-bold text-[24px] min-w-[60px]'>{hours} {hours === 1 ? t("hour") : t("hours")}</span>
                <button onClick={handleIncrement} className="w-10 h-10 rounded-full border-2 border-[--bg-color] text-[--bg-color] hover:bg-[--bg-color] hover:text-white flex items-center justify-center transition-all">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.75 12C19.75 12.414 19.414 12.75 19 12.75H12.75V19C12.75 19.414 12.414 19.75 12 19.75C11.586 19.75 11.25 19.414 11.25 19V12.75H5C4.586 12.75 4.25 12.414 4.25 12C4.25 11.586 4.586 11.25 5 11.25H11.25V5C11.25 4.586 11.586 4.25 12 4.25C12.414 4.25 12.75 4.586 12.75 5V11.25H19C19.414 11.25 19.75 11.586 19.75 12Z" fill="currentColor" />
                    </svg>
                </button>
            </div>
        </div>}

        <div className="mt-3">
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>📅</span> {t("Select Date & Time")}</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div onClick={() => setShowModel("Date")} className={`flex items-center justify-between border p-2 rounded-[10px] cursor-pointer transition-all ${date ? 'border-[--bg-color] text-[--bg-color]' : 'border-gray-200 text-gray-400'}`}>
                    <h1>{date ? date?.format("YYYY-MM-DD") : t("Select date")}</h1>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 3.75H16.75V3C16.75 2.586 16.414 2.25 16 2.25C15.586 2.25 15.25 2.586 15.25 3V3.75H8.75V3C8.75 2.586 8.414 2.25 8 2.25C7.586 2.25 7.25 2.586 7.25 3V3.75H6C3.582 3.75 2.25 5.082 2.25 7.5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V7.5C21.75 5.082 20.418 3.75 18 3.75ZM6 5.25H7.25V6C7.25 6.414 7.586 6.75 8 6.75C8.414 6.75 8.75 6.414 8.75 6V5.25H15.25V6C15.25 6.414 15.586 6.75 16 6.75C16.414 6.75 16.75 6.414 16.75 6V5.25H18C19.577 5.25 20.25 5.923 20.25 7.5V8.25H3.75V7.5C3.75 5.923 4.423 5.25 6 5.25ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V9.75H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM9.02002 13C9.02002 13.552 8.57302 14 8.02002 14C7.46802 14 7.01489 13.552 7.01489 13C7.01489 12.448 7.45801 12 8.01001 12H8.02002C8.57202 12 9.02002 12.448 9.02002 13ZM13.02 13C13.02 13.552 12.573 14 12.02 14C11.468 14 11.0149 13.552 11.0149 13C11.0149 12.448 11.458 12 12.01 12H12.02C12.572 12 13.02 12.448 13.02 13ZM17.02 13C17.02 13.552 16.573 14 16.02 14C15.468 14 15.0149 13.552 15.0149 13C15.0149 12.448 15.458 12 16.01 12H16.02C16.572 12 17.02 12.448 17.02 13ZM9.02002 17C9.02002 17.552 8.57302 18 8.02002 18C7.46802 18 7.01489 17.552 7.01489 17C7.01489 16.448 7.45801 16 8.01001 16H8.02002C8.57202 16 9.02002 16.448 9.02002 17ZM13.02 17C13.02 17.552 12.573 18 12.02 18C11.468 18 11.0149 17.552 11.0149 17C11.0149 16.448 11.458 16 12.01 16H12.02C12.572 16 13.02 16.448 13.02 17ZM17.02 17C17.02 17.552 16.573 18 16.02 18C15.468 18 15.0149 17.552 15.0149 17C15.0149 16.448 15.458 16 16.01 16H16.02C16.572 16 17.02 16.448 17.02 17Z" fill="currentColor" />
                    </svg>
                </div>
                <div onClick={() => setShowModel("Time")} className={`flex items-center justify-between border p-2 rounded-[10px] cursor-pointer transition-all ${time ? 'border-[--bg-color] text-[--bg-color]' : 'border-gray-200 text-gray-400'}`}>
                    <h1>{time ? time?.format('hh:mm A') : t("Select time")}</h1>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM15.53 14.47C15.823 14.763 15.823 15.238 15.53 15.531C15.384 15.677 15.192 15.751 15 15.751C14.808 15.751 14.616 15.678 14.47 15.531L11.47 12.531C11.329 12.39 11.25 12.199 11.25 12.001V7.00098C11.25 6.58698 11.586 6.25098 12 6.25098C12.414 6.25098 12.75 6.58698 12.75 7.00098V11.6899L15.53 14.47Z" fill="currentColor" />
                    </svg>
                </div>
            </div>
        </div>

        <button onClick={handleFareCalculate} className="min-h-12 w-full mt-3 rounded-[10px] bg-[--bg-color] hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-all active:scale-95 flex items-center justify-center gap-2">
            {apiLoading === "Choose"
                ? <BtnLoader CustomeStyle={"bg-white"} />
                : <><svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.86 18.75C9.668 18.75 9.48399 18.676 9.34399 18.543L4.34399 13.793C4.04599 13.509 4.035 13.034 4.319 12.736C4.603 12.437 5.078 12.427 5.376 12.711L9.843 16.953L18.609 7.47302C18.884 7.16602 19.358 7.14001 19.665 7.41401C19.972 7.68801 19.998 8.163 19.724 8.47L10.394 18.524C10.256 18.678 10.063 18.766 9.857 18.775L9.86 18.75Z" fill="white" /></svg>{t("Choose a ride")}</>}
        </button>

    </>
}

const Package = ({ pickupLocation, dropLocation, stopList, setModelData, setShowModel, date, time, setFareCalculate, packageData }) => {
    const { t } = useTranslation();
    const { BaseUrl, isAuth, handleCallApi, setShowToast, setToastMsg } = useContext(MyContext);

    const [apiLoading, setApiLoading] = useState("");
    const [vehicleList, setVehicleList] = useState([]);
    const [selectVehicle, setSelectVehicle] = useState("");
    const [imageList, setImageList] = useState([]);
    const [info, setInfo] = useState({ snumber: "", rnumber: "" });

    const ImgRef = useRef(null);
    const FetchRef = useRef(false);
    const Location = useLocation();

    useEffect(() => {
        handleFetchData();
    }, []);

    useEffect(() => {
        setModelData(selectVehicle);
    }, [selectVehicle]);

    const handleFetchData = async () => {
        if (FetchRef.current) return;
        FetchRef.current = true;
        const Response = await handleCallApi("Get", "cus_package/package_detail");
        setVehicleList(Response.data.category);
        setSelectVehicle(Response.data.category[0]);
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const GetUrl = reader.result.split(",")[1];
            setImageList([...imageList, GetUrl]);
        };
        reader.onerror = (error) => {
            console.error("Error: ", error);
        };
    };

    const handleRemoveimg = (Index) => {
        const FilterImg = imageList.filter((_, index) => index != Index);
        setImageList(FilterImg);
    }

    const handleFareCalculate = async () => {

        if (!pickupLocation) {
            setShowToast(true);
            setToastMsg("Please select pickup location !!");
            return;
        }

        if (!dropLocation) {
            setShowToast(true);
            setToastMsg("Please select dropoff location !!");
            return;
        }

        const hasEmptyStop = stopList.some(item => !item || !item.lat || !item.lng);
        if (hasEmptyStop) {
            setShowToast(true);
            setToastMsg("Please fill all stop locations !!");
            return;
        }

        if (!isAuth) {
            setShowModel("Login");
            return;
        }

        if (!info?.snumber) {
            setShowToast(true);
            setToastMsg(t("Please enter sender phone number !!"));
            return;
        }

        if (!info?.rnumber) {
            setShowToast(true);
            setToastMsg(t("Please enter receiver phone number !!"));
            return;
        }

        if (!selectVehicle) {
            setShowToast(true);
            setToastMsg(t("Please select a vehicle size !!"));
            return;
        }

        if (!date) {
            setShowToast(true);
            setToastMsg(t("Please select a booking date !!"));
            return;
        }

        if (!time) {
            setShowToast(true);
            setToastMsg(t("Please select a booking time !!"));
            return;
        }

        if (!packageData?.kg) {
            setShowToast(true);
            setToastMsg(t("Please enter package weight !!"));
            return;
        }

        if (!packageData?.length || !packageData?.weight || !packageData?.height) {
            setShowToast(true);
            setToastMsg(t("Please enter package dimensions !!"));
            return;
        }

        if (!packageData?.desc) {
            setShowToast(true);
            setToastMsg(t("Please enter package description !!"));
            return;
        }

        const DropList = stopList?.map((item) => item && ({ lat: item?.lat, long: item?.lng }));
        const ApiBody = {
            package_id: selectVehicle?.id,
            tot_kg: packageData?.kg,
            pickup_lat_lon: `${pickupLocation?.lat},${pickupLocation?.lng}`,
            drop_lat_lon: `${dropLocation?.lat},${dropLocation?.lng}`,
            drop_lat_lon_list: DropList || []
        }

        setApiLoading("Create");
        const Response = await handleCallApi("Post", "cus_package/package_fare_calculate", ApiBody);
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            const Object = {
                ...packageData,
                ...selectVehicle,
                ...Response.data,
                bid_addjust_amount: Response.data?.tot_price,
                book_date: date.format("YYYY-MM-DD"),
                book_time: time.format('hh:mm A'),
                m_role: Location.state,
                sender_number: info?.snumber,
                reciver_number: info?.rnumber,
                imageList: imageList
            };
            setFareCalculate(Object);
            setShowModel("FareCalculate");
        }
        setApiLoading("");
    }

    return <>

        <div>
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>📱</span> {t("Sender & Receiver Info")}</h1>

            <div className="space-y-3">
                <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.45 22.75C16.32 22.75 15.13 22.53 13.9 22.09C12.7 21.66 11.49 21.04 10.31 20.24C9.14 19.44 8.01 18.5 6.94 17.43C5.88 16.37 4.94 15.24 4.13 14.06C3.33 12.87 2.71 11.67 2.28 10.47C1.85 9.24 1.63 8.05 1.63 6.92C1.63 6.15 1.76 5.42 2.02 4.74C2.28 4.05 2.69 3.41 3.24 2.84C3.95 2.12 4.75 1.75 5.59 1.75C5.98 1.75 6.38 1.85 6.72 2.04C7.11 2.26 7.43 2.59 7.64 3.01L9.52 6.37C9.71 6.71 9.84 7.03 9.93 7.35C10.03 7.7 10.08 8.05 10.08 8.38C10.08 8.82 9.96 9.24 9.73 9.63C9.56 9.93 9.32 10.24 9.01 10.55L8.2 11.39C8.31 11.63 8.48 11.93 8.73 12.29C9.14 12.89 9.59 13.48 10.12 14.07C10.67 14.67 11.18 15.19 11.7 15.63C12.08 15.93 12.37 16.14 12.59 16.27L13.41 15.46C13.74 15.13 14.07 14.88 14.39 14.71C15.01 14.33 15.79 14.25 16.59 14.54C16.89 14.64 17.21 14.78 17.55 14.97L20.97 16.89C21.4 17.14 21.73 17.46 21.94 17.85C22.14 18.24 22.24 18.62 22.24 19C22.24 19.54 22.11 20.08 21.86 20.59C21.61 21.1 21.29 21.54 20.89 21.93C20.32 22.5 19.69 22.9 18.97 23.15C18.3 23.38 17.89 22.75 17.45 22.75Z" fill="currentColor"/></svg>
                    </span>
                    <input type="tel" value={info.snumber} onChange={(e) => setInfo({ ...info, snumber: e.target.value })} className='w-full bg-gray-50 pl-10 pr-4 py-3 outline-[--bg-color] rounded-[10px] border border-gray-200 focus:bg-white focus:border-[--bg-color] transition-all' placeholder={t("Sender Phone Number")} />
                </div>
                <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.45 22.75C16.32 22.75 15.13 22.53 13.9 22.09C12.7 21.66 11.49 21.04 10.31 20.24C9.14 19.44 8.01 18.5 6.94 17.43C5.88 16.37 4.94 15.24 4.13 14.06C3.33 12.87 2.71 11.67 2.28 10.47C1.85 9.24 1.63 8.05 1.63 6.92C1.63 6.15 1.76 5.42 2.02 4.74C2.28 4.05 2.69 3.41 3.24 2.84C3.95 2.12 4.75 1.75 5.59 1.75C5.98 1.75 6.38 1.85 6.72 2.04C7.11 2.26 7.43 2.59 7.64 3.01L9.52 6.37C9.71 6.71 9.84 7.03 9.93 7.35C10.03 7.7 10.08 8.05 10.08 8.38C10.08 8.82 9.96 9.24 9.73 9.63C9.56 9.93 9.32 10.24 9.01 10.55L8.2 11.39C8.31 11.63 8.48 11.93 8.73 12.29C9.14 12.89 9.59 13.48 10.12 14.07C10.67 14.67 11.18 15.19 11.7 15.63C12.08 15.93 12.37 16.14 12.59 16.27L13.41 15.46C13.74 15.13 14.07 14.88 14.39 14.71C15.01 14.33 15.79 14.25 16.59 14.54C16.89 14.64 17.21 14.78 17.55 14.97L20.97 16.89C21.4 17.14 21.73 17.46 21.94 17.85C22.14 18.24 22.24 18.62 22.24 19C22.24 19.54 22.11 20.08 21.86 20.59C21.61 21.1 21.29 21.54 20.89 21.93C20.32 22.5 19.69 22.9 18.97 23.15C18.3 23.38 17.89 22.75 17.45 22.75Z" fill="currentColor"/></svg>
                    </span>
                    <input type="tel" value={info.rnumber} onChange={(e) => setInfo({ ...info, rnumber: e.target.value })} className='w-full bg-gray-50 pl-10 pr-4 py-3 outline-[--bg-color] rounded-[10px] border border-gray-200 focus:bg-white focus:border-[--bg-color] transition-all' placeholder={t("Receiver Phone Number")} />
                </div>
            </div>

        </div>

        <div className='mt-3'>
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>🚚</span> {t("Vehicle Size")}</h1>
            <div>
                <Swiper
                    slidesPerView={"auto"}
                    spaceBetween={10}
                    modules={[Navigation]}
                    className="mySwiper">
                    {vehicleList.map((item, index) => {
                        const IsSelected = item.id === selectVehicle?.id;
                        return <SwiperSlide key={index} style={{ width: "90%" }} onClick={() => setSelectVehicle(item)} className={`${IsSelected ? "bg-[#4038ff]/10" : "bg-gray-100"} p-3 rounded-[10px] cursor-pointer`}>
                            <div className="flex items-stretch gap-3">
                                <ImageLoad src={BaseUrl + item.image} CustomeStyle={"max-w-[100px] min-w-[100px] h-[100px]"} ImagStyle={"w-full h-full object-contain"} alt={item.name} status={false} />
                                <div className="space-y-1 flex flex-col justify-between">
                                    <h1 className='font-semibold'>{item.name}</h1>
                                    <p className='text-[14px] leading-4'>{item.sub_title}</p>
                                    <div className="flex items-center text-[14px]">
                                        <div className='text-center'>
                                            <p className='border border-gray-400 px-2 py-[1px] rounded-[5px_0_0_0]'>{t("Length")}</p>
                                            <p className='border border-gray-400 px-2 py-[1px] rounded-[0_0_0_5px]'>{item.length}</p>
                                        </div>
                                        <div className='text-center'>
                                            <p className='border border-gray-400 px-2 py-[1px]'>{t("Width")}</p>
                                            <p className='border border-gray-400 px-2 py-[1px]'>{item.weight}</p>
                                        </div>
                                        <div className='text-center'>
                                            <p className='border border-gray-400 px-2 py-[1px] rounded-[0_5px_0_0]'>{t("Height")}</p>
                                            <p className='border border-gray-400 px-2 py-[1px] rounded-[0_0_5px_0]'>{item.height}</p>
                                        </div>
                                    </div>
                                    {item.num_of_kg && <div className="flex items-center gap-1.5 mt-1">
                                        <span className="inline-flex items-center gap-1 bg-orange-100 text-orange-700 text-[12px] font-semibold px-2 py-[2px] rounded-full">
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12.75 16.5C12.75 16.914 12.414 17.25 12 17.25C11.586 17.25 11.25 16.914 11.25 16.5V11C11.25 10.586 11.586 10.25 12 10.25C12.414 10.25 12.75 10.586 12.75 11V16.5ZM12.92 8.38C12.87 8.5 12.8 8.61 12.71 8.71C12.61 8.8 12.5 8.87 12.38 8.92C12.26 8.97 12.13 9 12 9C11.87 9 11.74 8.97 11.62 8.92C11.5 8.87 11.39 8.8 11.29 8.71C11.2 8.61 11.13 8.5 11.08 8.38C11.03 8.26 11 8.13 11 8C11 7.87 11.03 7.74 11.08 7.62C11.13 7.5 11.2 7.39 11.29 7.29C11.39 7.2 11.5 7.13 11.62 7.08C11.86 6.98 12.14 6.98 12.38 7.08C12.5 7.13 12.61 7.2 12.71 7.29C12.8 7.39 12.87 7.5 12.92 7.62C12.97 7.74 13 7.87 13 8C13 8.13 12.97 8.26 12.92 8.38Z" fill="currentColor"/></svg>
                                            {t("Max")} {item.num_of_kg} kg
                                        </span>
                                    </div>}
                                </div>
                            </div>
                        </SwiperSlide>
                    })}
                </Swiper>
            </div>
        </div>

        <div className="mt-3">
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>📅</span> {t("Select Date & Time")}</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div onClick={() => setShowModel("Date")} className={`flex items-center justify-between border p-2 rounded-[10px] cursor-pointer transition-all ${date ? 'border-[--bg-color] text-[--bg-color]' : 'border-gray-200 text-gray-400'}`}>
                    <h1>{date ? date?.format("YYYY-MM-DD") : t("Select date")}</h1>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 3.75H16.75V3C16.75 2.586 16.414 2.25 16 2.25C15.586 2.25 15.25 2.586 15.25 3V3.75H8.75V3C8.75 2.586 8.414 2.25 8 2.25C7.586 2.25 7.25 2.586 7.25 3V3.75H6C3.582 3.75 2.25 5.082 2.25 7.5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V7.5C21.75 5.082 20.418 3.75 18 3.75ZM6 5.25H7.25V6C7.25 6.414 7.586 6.75 8 6.75C8.414 6.75 8.75 6.414 8.75 6V5.25H15.25V6C15.25 6.414 15.586 6.75 16 6.75C16.414 6.75 16.75 6.414 16.75 6V5.25H18C19.577 5.25 20.25 5.923 20.25 7.5V8.25H3.75V7.5C3.75 5.923 4.423 5.25 6 5.25ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V9.75H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM9.02002 13C9.02002 13.552 8.57302 14 8.02002 14C7.46802 14 7.01489 13.552 7.01489 13C7.01489 12.448 7.45801 12 8.01001 12H8.02002C8.57202 12 9.02002 12.448 9.02002 13ZM13.02 13C13.02 13.552 12.573 14 12.02 14C11.468 14 11.0149 13.552 11.0149 13C11.0149 12.448 11.458 12 12.01 12H12.02C12.572 12 13.02 12.448 13.02 13ZM17.02 13C17.02 13.552 16.573 14 16.02 14C15.468 14 15.0149 13.552 15.0149 13C15.0149 12.448 15.458 12 16.01 12H16.02C16.572 12 17.02 12.448 17.02 13ZM9.02002 17C9.02002 17.552 8.57302 18 8.02002 18C7.46802 18 7.01489 17.552 7.01489 17C7.01489 16.448 7.45801 16 8.01001 16H8.02002C8.57202 16 9.02002 16.448 9.02002 17ZM13.02 17C13.02 17.552 12.573 18 12.02 18C11.468 18 11.0149 17.552 11.0149 17C11.0149 16.448 11.458 16 12.01 16H12.02C12.572 16 13.02 16.448 13.02 17ZM17.02 17C17.02 17.552 16.573 18 16.02 18C15.468 18 15.0149 17.552 15.0149 17C15.0149 16.448 15.458 16 16.01 16H16.02C16.572 16 17.02 16.448 17.02 17Z" fill="currentColor" />
                    </svg>
                </div>
                <div onClick={() => setShowModel("Time")} className={`flex items-center justify-between border p-2 rounded-[10px] cursor-pointer transition-all ${time ? 'border-[--bg-color] text-[--bg-color]' : 'border-gray-200 text-gray-400'}`}>
                    <h1>{time ? time?.format('hh:mm A') : t("Select time")}</h1>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM15.53 14.47C15.823 14.763 15.823 15.238 15.53 15.531C15.384 15.677 15.192 15.751 15 15.751C14.808 15.751 14.616 15.678 14.47 15.531L11.47 12.531C11.329 12.39 11.25 12.199 11.25 12.001V7.00098C11.25 6.58698 11.586 6.25098 12 6.25098C12.414 6.25098 12.75 6.58698 12.75 7.00098V11.6899L15.53 14.47Z" fill="currentColor" />
                    </svg>
                </div>
            </div>
        </div>

        <div className="mt-3">
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>📋</span> {t("Package Details")}</h1>

            <button onClick={() => setShowModel("Package")} className='w-full bg-gray-50 px-4 py-3 outline-[--bg-color] rounded-[10px] border border-gray-200 hover:border-[--bg-color] transition-all flex items-center justify-between'>
                {(packageData?.kg || (packageData?.length && packageData?.weight && packageData?.height)) ? (
                    <div className="flex flex-col items-start gap-1 text-[14px]">
                        {packageData?.kg && <div className="flex items-center gap-1.5">
                            <span className="text-gray-500">{t("Weight")}:</span>
                            <span className="font-semibold text-gray-800">{packageData.kg} kg</span>
                        </div>}
                        {(packageData?.length && packageData?.weight && packageData?.height) && <div className="flex items-center gap-1.5">
                            <span className="text-gray-500">{t("Dimensions")}:</span>
                            <span className="font-semibold text-gray-800">{packageData.length} × {packageData.weight} × {packageData.height} ft</span>
                        </div>}
                        {packageData?.desc && <div className="flex items-center gap-1.5">
                            <span className="text-gray-500">{t("Item")}:</span>
                            <span className="font-medium text-gray-700 truncate max-w-[250px]">{packageData.desc}</span>
                        </div>}
                    </div>
                ) : (
                    <span className="text-gray-400">{t("Enter details")}</span>
                )}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 ml-2">
                    <path d="M10 16.75C9.80802 16.75 9.61599 16.6771 9.46999 16.5301C9.17699 16.2371 9.17699 15.762 9.46999 15.469L12.94 11.999L9.46999 8.52908C9.17699 8.23608 9.17699 7.76104 9.46999 7.46804C9.76299 7.17504 10.238 7.17504 10.531 7.46804L14.531 11.468C14.824 11.761 14.824 12.2361 14.531 12.5291L10.531 16.5291C10.384 16.6771 10.192 16.75 10 16.75Z" fill="currentColor" />
                </svg>
            </button>
        </div>

        <div className="mt-3">
            <h1 className="font-semibold text-[17px] mb-2 flex items-center gap-2"><span>📷</span> {t("Upload Package Photos")}</h1>
            <Swiper
                slidesPerView={"auto"}
                spaceBetween={10}
                modules={[Navigation]}
                className="mySwiper">
                <SwiperSlide onClick={() => ImgRef.current.click()} style={{ width: "100px", height: "100px" }} className="bg-gray-100 rounded-[10px] cursor-pointer my-2">
                    <div className="h-full flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.75 12C19.75 12.414 19.414 12.75 19 12.75H12.75V19C12.75 19.414 12.414 19.75 12 19.75C11.586 19.75 11.25 19.414 11.25 19V12.75H5C4.586 12.75 4.25 12.414 4.25 12C4.25 11.586 4.586 11.25 5 11.25H11.25V5C11.25 4.586 11.586 4.25 12 4.25C12.414 4.25 12.75 4.586 12.75 5V11.25H19C19.414 11.25 19.75 11.586 19.75 12Z" fill="black" />
                        </svg>
                    </div>
                </SwiperSlide>
                {imageList.map((item, index) => (
                    <SwiperSlide key={index} style={{ width: "100px", height: "100px", overflow: "none" }} className="relative my-2">
                        <img src={`data:image/png;base64,${item}`} className='w-full h-full object-cover rounded-[10px]' alt="img" />
                        <button onClick={() => handleRemoveimg(index)} className='absolute z-20 -top-2 -right-2'>
                            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className='text-[--bg-color]' d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor" />
                                <path className='text-white' d="M13.061 12L15.531 9.53005C15.824 9.23705 15.824 8.76202 15.531 8.46902C15.238 8.17602 14.763 8.17602 14.47 8.46902L12 10.939L9.52999 8.46902C9.23699 8.17602 8.76199 8.17602 8.46899 8.46902C8.17599 8.76202 8.17599 9.23705 8.46899 9.53005L10.939 12L8.46899 14.47C8.17599 14.763 8.17599 15.238 8.46899 15.531C8.61499 15.677 8.80699 15.751 8.99899 15.751C9.19099 15.751 9.38298 15.678 9.52898 15.531L11.999 13.061L14.469 15.531C14.615 15.677 14.807 15.751 14.999 15.751C15.191 15.751 15.383 15.678 15.529 15.531C15.822 15.238 15.822 14.763 15.529 14.47L13.061 12Z" fill="currentColor" />
                            </svg>
                        </button>
                    </SwiperSlide>
                ))}
            </Swiper>

            <input ref={ImgRef} accept='image/*' onChange={(e) => handleImageChange(e)} type="file" className='hidden' />
        </div>

        <button onClick={handleFareCalculate} className="min-h-12 w-full mt-3 rounded-[10px] bg-[--bg-color] hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-all active:scale-95 flex items-center justify-center gap-2">
            {apiLoading === "Create"
                ? <BtnLoader CustomeStyle={"bg-white"} />
                : <><svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16 13H13V16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16V13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z" fill="white" /></svg>{t("Create request")}</>}
        </button>
    </>

}

const getTooltipText = (id, fareCalculate, currency) => {
    const cur = currency || "$";
    switch (id) {
        case 1: 
            return `Total distance calculated: ${fareCalculate?.tot_km || 0} km.`;
        case 2: 
            return `Estimated hours required: ${fareCalculate?.tot_hour || 0} hr.`;
        case 3: 
            return `Estimated ride duration: ${fareCalculate?.tot_minute || 0} min.`;
        case 4: {
            const rate = fareCalculate?.extra_charge_rate || 0;
            return `Extra surcharge: ${cur}${rate} = ${cur}${fareCalculate?.extra_charge || 0}.`;
        }
        case 5: {
            const isFix = fareCalculate?.weather_type?.trim()?.toLowerCase() === 'fix';
            const rate = fareCalculate?.weather_price || 0;
            return `Weather surcharge: ${isFix ? `${cur}${rate} fixed` : `${rate}% of subtotal`} = ${cur}${fareCalculate?.weather_charge || 0}.`;
        }
        case 6: {
            const passengerPrice = fareCalculate?.per_person_price || 0;
            const count = fareCalculate?.num_passenger || 0;
            return `Passenger fee: ${count} passenger(s) × ${cur}${passengerPrice} = ${cur}${fareCalculate?.extra_person_charge || 0}.`;
        }
        case 7: 
            return `Premium day booking charge: ${cur}${fareCalculate?.day_charge || 0}.`;
        case 8: {
            const hourRate = fareCalculate?.per_hour_charge || 0;
            const hours = fareCalculate?.rent_hour || 0;
            return `Rental hours: ${hours} hr × ${cur}${hourRate}/hr = ${cur}${fareCalculate?.hour_charge || 0}.`;
        }
        case 9: {
            const discountRate = fareCalculate?.per_hour_discount_rate || 0;
            const hours = fareCalculate?.rent_hour || 0;
            return `Discount: ${hours} hr × ${cur}${discountRate}/hr = -${cur}${fareCalculate?.per_hour_discount || 0}.`;
        }
        case 10: {
            // Check if it's Outstation (has min_km_distance config)
            if (fareCalculate?.min_km_distance !== undefined) {
                const minKm = fareCalculate?.min_km_distance || 0;
                const minPrice = fareCalculate?.min_km_price || 0;
                const afterPrice = fareCalculate?.after_km_price || 0;
                const distance = fareCalculate?.tot_km || 0;
                if (distance <= minKm) {
                    return `Base fare: ${distance} km × ${cur}${minPrice}/km (within base ${minKm} km) = ${cur}${fareCalculate?.km_charge || 0}.`;
                } else {
                    const addKm = (distance - minKm).toFixed(2);
                    const baseCharge = (minKm * minPrice).toFixed(2);
                    const extraCharge = (addKm * afterPrice).toFixed(2);
                    return `Distance: Base (${minKm} km × ${cur}${minPrice}/km) + Extra (${addKm} km × ${cur}${afterPrice}/km) = ${cur}${baseCharge} + ${cur}${extraCharge} = ${cur}${fareCalculate?.km_charge || 0}.`;
                }
            }
            // Package
            const rate = fareCalculate?.up_to_fee || 0;
            const distance = fareCalculate?.tot_km || 0;
            return `Distance fee: ${distance} km × ${cur}${rate}/km = ${cur}${fareCalculate?.km_charge || 0}.`;
        }
        case 11: {
            const rate = fareCalculate?.per_kg_price || 0;
            const weight = fareCalculate?.kg || 0;
            return `Weight fee: ${weight} kg × ${cur}${rate}/kg = ${cur}${fareCalculate?.kg_charge || 0}.`;
        }
        case 12: {
            const rate = fareCalculate?.comission_rate || 0;
            const isFix = fareCalculate?.comission_type?.trim()?.toLowerCase() === 'fix';
            return `Platform commission: ${isFix ? `${cur}${rate} fixed` : `${rate}% fee`} = ${cur}${fareCalculate?.site_commission || 0}.`;
        }
        default: return "";
    }
};